import React, { useContext, useCallback } from 'react';
import Hand from '../../../assets/logos/logoHand.svg';

import MyContext from '../../../contexts/_ModalData/modal';

import './styles.css';

const DenunciationsCard = (denunce) => {
    // console.log(denunce, 'denunceinDenunciations');
    const { setDenunciations } = useContext(MyContext);

    function getAlertLevel(riskAverage) {
        if (riskAverage > 0.774) return 5;
        else if (riskAverage > 0.5424) return 4;
        else if (riskAverage > 0.274) return 3;
        else if (riskAverage > 0.024) return 2;
        else if (riskAverage === 0) return 0;
        else return 1;
    }

    const handleModal = useCallback(async () => {
        // console.log('clicou em handleModal ver denuncias');
        // const data = props.data;
        setDenunciations(denunce.data);
        // props.setDenunciations(true);
        denunce.setShowModal(true);
    }, [denunce, setDenunciations]);

    return (
        <div className='card-profiles'>
            <div className='card-profiles-image'>
                <img src={Hand} alt="hand"/>
            </div>

            <div className='card-profiles-info'>
                <p className='card-profiles-text-UP'>
                    {denunce.data.title.length > 15 ? 
                            (denunce.data.title.substr(0,15)+'...')
                        : 
                        denunce.data.title
                    }
                </p>
                <p className='card-profiles-text'>
                    
                        {{
                            1: 'Leve',
                            2: 'Moderado',
                            3: 'Grave',
                            4: 'Muito grave',
                            5: 'Máximo',
                        }[getAlertLevel(denunce.data.risk)]}
                </p>

                <p className='card-profiles-text-UP-de'>
                    Denunciante:  
                        {denunce.data.users.length > 15 ? 
                            (' '+denunce.data.users.substr(0,15)+'...')
                        : 
                            denunce.data.users
                        }
                </p>
                <p className='card-profiles-text-button' id='show-data-button'onClick={handleModal}>Ver denúncias</p>
            </div>
        </div>
    )
}


export default DenunciationsCard